import { render, staticRenderFns } from "./ProjectItemsConsumed.vue?vue&type=template&id=6cbcdeb0&scoped=true"
import script from "./ProjectItemsConsumed.vue?vue&type=script&lang=js"
export * from "./ProjectItemsConsumed.vue?vue&type=script&lang=js"
import style0 from "./ProjectItemsConsumed.vue?vue&type=style&index=0&id=6cbcdeb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbcdeb0",
  null
  
)

export default component.exports